import React from "react";
import { Document, Page } from "react-pdf";
import PDFControls from "./PDFControls";
import SignaturePosition from "./SignaturePosition";
import Loader from "./Loader";

const DocumentViewer = ({
  pdfUrl,
  signaturePositions,
  onSignatureClick,
  onDocumentLoadSuccess,
  currentPage,
  scale,
  setCurrentPage,
  setScale,
  containerRef,
  numPages,
  onRemoveSign,
  handleUploadClick,
}) => {
  return (
    <div>
      <div className="ps-toolbar">
        <h2 className="ps-heading">Document Preview</h2>

        <button className="ps-button blue" onClick={handleUploadClick}>
          Upload Signature
        </button>
      </div>

      <PDFControls
        numPages={numPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        scale={scale}
        setScale={setScale}
      />

      <div ref={containerRef} className="ps-pdf-container">
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Loader size="large" text="Loading PDF…" />}
        >
          <Page
            pageNumber={currentPage}
            scale={scale}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />

          {signaturePositions?.map(
            (pos, index) =>
              Number(pos?.page) === currentPage && (
                <SignaturePosition
                  key={index}
                  position={pos}
                  containerRef={containerRef}
                  onSignatureClick={onSignatureClick}
                  onRemoveSign={() => onRemoveSign(index)}
                />
              )
          )}
        </Document>
      </div>
    </div>
  );
};

export default DocumentViewer;
